import IBModuleApi from "../../api/iuviBankingAPI";
import { urlContexts } from "../../constants";

export const getProperties = async (appId: string, filter: string) => {
  const { data } = await IBModuleApi.get(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/properties?appId=${appId}&type=${filter}`
  );

  return data;
};

export const createProperty = async (createInfo: any, appId: string) => {
  const { data } = await IBModuleApi.post(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/properties?appId=${appId}`,
    createInfo
  );

  return data;
};

export const updateProperty = async (updateInfo: any, appId: string) => {
  const { data } = await IBModuleApi.put(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/properties?appId=${appId}`,
    updateInfo
  );

  return data;
};

export const deleteProperty = async (propertyId: number) => {
  const { data } = await IBModuleApi.delete(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/properties/${propertyId}`
  );

  return data;
};
